export const INVALID_CREDENTIALS_ERROR = 'Invalid login or password.'
export const WRONG_OTP_ERROR = 'Wrong code entered, please try again.'
export const EMAIL_PHONE_ALREADY_REGISTERED_ERROR = 'This email or phone number is already registered.'
export const INVALID_LINK_ERROR = 'Invalid invitation link, please try again.'
export const PHONE_NUMBER_TAKEN_ERROR = 'Phone Number is already taken'
export const SERVER_DOWN_ERROR = 'We’re sorry, this invitation link is expired. Please check your inbox for a more recent invitation or email support@utilizecore.com for assistance'
export const EMAIL_OR_PHONE_REQ = 'Email or Phone*'
export const EMAIL_TAKEN_ERROR = 'Email already been taken'
